import { render } from "./LessonsTable.vue?vue&type=template&id=6e3d89fd&scoped=true"
import script from "./LessonsTable.vue?vue&type=script&lang=js"
export * from "./LessonsTable.vue?vue&type=script&lang=js"

import "./LessonsTable.vue?vue&type=style&index=0&id=6e3d89fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3d89fd"]])

export default __exports__